import { MutationTree } from "vuex";
import { UserState } from "./types";
import firebase from "firebase/app";

const SET_USER = "SET_USER";
const CLEAR_USER = "CLEAR_USER";

const n = {
  SET_USER,
  CLEAR_USER,
};

export const mutations: MutationTree<UserState> = {
  [n.SET_USER](state, payload: firebase.UserInfo | null) {
    console.log(n.SET_USER, payload);
    state.user = payload;
  },
  [n.CLEAR_USER](state) {
    state.user = null;
  },
};

export const mutationNames = n;
